import { createTranslatedText } from '@dreryk/react-common';

export const EMPTY_DISABLED_VALUE = createTranslatedText('-');
